/* eslint-disable @next/next/no-img-element */
import { FC } from 'react'
import styles from './AthletesStats.module.scss'
import { Img } from 'components/basic/Img'

interface AthletesStatsProps {
	className?: string
}

export const AthletesStats: FC<AthletesStatsProps> = (props) => {
	return (
		<div className={`inner-paddings-y inner-paddings-x max-1440 ${props.className}`}>
			<small className={styles.supline}>The science</small>
			<h2 className={styles.h2}>No compromise in sleep fitness</h2>
			<p className={styles.subtitle}>How the Pod helps athletes towards peak performance and recovery:</p>
			<div className={styles.container}>
				<div className="athlete_box">
					<p>Pod users completed more high intensity exercise on average</p>
					<Img
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-science-chart1.png"
						alt="pie chart"
					/>
					<span>+65%</span>
				</div>
				<div className="athlete_box">
					<p>Pod users saw improvements in their heart rate variability (HRV)</p>
					<Img
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-science-chart2.png"
						alt="pie chart"
					/>
					<span>+17%</span>
				</div>
				<div className="athlete_box">
					<p>Pod users experienced faster response times</p>
					<Img
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-science-chart3.png"
						alt="pie chart"
					/>
					<span>+8%</span>
				</div>
			</div>
		</div>
	)
}
